const validator = {
  /**
   * [validate description]
   * @param  {[type]} value  [description]
   * @param  {[type]} length [description]
   * @return {Boolean}       Retorna se o campo é valido
   */
  validate (value, [length]) {
    if (value === undefined || value === null) {
      return false
    }
    return value >= length
  }
}

export default validator
